// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Wm7H2","footer":"styles_footer__2tjjr","passCodeTooltip":"styles_passCodeTooltip__CJCUY"};